<template>
    <div>
        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer
            ref="modal-dialog-question">
            <div class="container modal-warning text-center">
                <h5 class="text">Đề chưa được lưu. Bạn chắc chắn muốn thoát?</h5>
                <div class="block__actions">
                    <button class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold  line-height-1"
                        @click="handleHideModal">Hủy</button>
                    <button @click="handleAccess"
                        class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold line-height-1">Đồng
                        ý</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'ModalDialogCloseQuestion',

    mounted() {

        this.handleShowModal()
    },
    methods: {
        handleHideModal() {
            //this.$refs['modal-assign-excercise'].hide()
            this.$emit('closeModal')
        },
        handleAccess() {
            this.$emit('closeModalComfirmQuestion')
        },
        handleShowModal() {
            this.$refs['modal-dialog-question'].show()
        },
    }
}
</script>

<style>
.modal-warning{
    background-color: white;
}
.text-center {
    text-align: center;
}

.block__actions {
    margin-top: 20px;

}

.text {
    color: red;
}
</style>